module.exports = __webpack_public_path__ + "img/hk_room2.2585d940.jpg";